export default __webpack_public_path__ + "static/media/frame-2.63133a35.png";